var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',_vm._b({class:'switch-display',attrs:{"hide-details":""},on:{"change":function($event){_vm.$emit('on-switch-change', { model: _vm.model, value: $event })}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-switch',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f23a65d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/market-place/switch-display.vue
// module id = 658
// module chunks = 2 4